import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ProjectHeaderComponent } from '../project-header/project-header.component';

@Component({
  selector: 'app-project-layout',
  standalone: true,
  imports: [RouterOutlet, ProjectHeaderComponent],
  templateUrl: 'project-layout.component.html',
  styleUrls: ['project-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectLayoutComponent {}
